// Elenco delle novità mostrate in home al titolare.
// AGGIORNARE A OGNI NUOVA FUNZIONE: aggiungi una voce in cima e alza NOVITA_VERSIONE.
export const NOVITA_VERSIONE = "2.9";

export const NOVITA = [
  {
    v: "2.9",
    data: "06/07/2026",
    titolo: "La cassa dei colleghi non è affar di nessuno",
    testo: "Un cameriere ora vede soltanto i propri incassi e il proprio fondo cassa: quelli degli altri e i totali del locale restano alla direzione. Il filtro è sul server, quindi quei numeri non arrivano nemmeno sul telefono di chi non deve vederli.",
    to: "/cassa",
    cta: "Guarda la cassa",
  },
  {
    v: "2.9",
    data: "06/07/2026",
    titolo: "Scegli i colori: Chiaro, Notte o Ambra",
    testo: "Di sera un fondo scuro non acceca il cameriere in sala e non si vede dal tavolo del cliente. La scelta vale sul singolo telefono, così ognuno lavora come sta meglio, e tu decidi con quale tema partono i dispositivi nuovi. Il menu del titolare è anche riordinato in quattro gruppi: Servizio, Menu e prodotti, Persone, Soldi e documenti.",
    to: "/impostazioni",
    cta: "Scegli il tuo tema",
  },
  {
    v: "2.8",
    data: "06/07/2026",
    titolo: "Calendario turni, se ti serve",
    testo: "Opzionale: lo accendi tu. Per ogni persona compili una volta la settimana (riposo oppure orario) e si ripete; se un giorno cambia, correggi solo quel giorno. In «Serata» vedi «Chi c'è oggi» e, se vuoi, il calendario comanda anche l'accesso al gestionale. Lo vedono tutti, lo cambia solo la direzione.",
    to: "/dipendenti",
    cta: "Accendi il calendario",
  },
  {
    v: "2.7",
    data: "06/07/2026",
    titolo: "Il personale entra col QR, senza dettare codici",
    testo: "In «Dipendenti e credenziali» trovi un QR e un link da far inquadrare al tuo staff: arrivano diritti ai nomi e al tastierino, senza sapere il codice del locale. Il PIN resta obbligatorio e lo mandi su WhatsApp, per SMS o copiandolo. Se qualcuno se ne va, un tocco su «Fai un codice nuovo» e il vecchio QR non vale più.",
    to: "/dipendenti",
    cta: "Attiva l'ingresso col QR",
  },
  {
    v: "2.7",
    data: "06/07/2026",
    titolo: "Entrano solo nel proprio turno (se vuoi)",
    testo: "Metti l'orario di turno sulla scheda di ogni persona e accendi il blocco: fuori da quell'orario non si entra, con 20 minuti di tolleranza. Ferie, malattia e riposo bloccano già l'accesso. Titolare e direttore entrano sempre.",
    to: "/dipendenti",
    cta: "Imposta i turni",
  },
  {
    v: "2.7",
    data: "06/07/2026",
    titolo: "Ricerca dei piatti più intelligente",
    testo: "Tre lettere e il piatto giusto è in cima: chi inizia con quelle lettere viene prima, gli accenti non contano («ragu» trova «Ragù») e puoi cercare anche per categoria. Con Invio aggiungi subito il primo risultato.",
    to: "/sala",
    cta: "Provalo su una comanda",
  },
  {
    v: "2.6",
    data: "06/07/2026",
    titolo: "Nessuno entra nel tuo gestionale senza il tuo «sì»",
    testo: "L'assistenza deve chiederti il permesso indicando il motivo: tu autorizzi, l'accesso vale un'ora e si chiude da solo. In Impostazioni trovi il registro di chi è entrato, quando e perché — righe che nessuno può cancellare. Se la lista è vuota, è la prova che nessuno ha mai messo il naso nel tuo locale.",
    to: "/impostazioni",
    cta: "Apri il registro accessi",
  },
  {
    v: "2.6",
    data: "06/07/2026",
    titolo: "Il cliente ti chiama dal tavolo col QR",
    testo: "Inquadra il QR, legge il menu e con un tocco chiede il cameriere, il conto o acqua e pane. In Sala compare la fascia «Chiamate dai tavoli» con «Ci vado io» e «Fatto». Decidi tu a chi arriva: tutta la sala, il cameriere della zona, quello del tavolo o una persona precisa (direttore di sala o titolare). Le richieste le scrivi tu. Contro le chiamate inutili: una sola chiamata aperta per tavolo, attesa dopo ogni «Fatto», tetto per serata e passaggio a tutta la sala se nessuno risponde.",
    to: "/impostazioni",
    cta: "Configura le chiamate",
  },
  {
    v: "2.6",
    data: "06/07/2026",
    titolo: "QR dedicato a ogni tavolo",
    testo: "In Menu fisso scrivi il numero del tavolo e il PDF esce già legato a quel tavolo: il cliente non deve scegliere niente e la chiamata arriva col numero giusto.",
    to: "/menu-fisso",
    cta: "Stampa i QR dei tavoli",
  },
  {
    v: "2.6",
    data: "06/07/2026",
    titolo: "Report di chiusura via email",
    testo: "Archivi la serata e ti arriva il riepilogo: incassato, metodi di pagamento, coperti, scontrino medio, differenza di cassa, sconti e piatti più venduti. Puoi mandarlo anche al socio o al commercialista.",
    to: "/impostazioni",
    cta: "Attiva il report",
  },
  {
    v: "2.5",
    data: "05/07/2026",
    titolo: "Voce italiana e campanella per reparto",
    testo: "In cucina suona una campanella (tono diverso per cucina, pizzeria e bar) e poi parla la voce italiana del telefono, più grave in cucina per farsi capire nel rumore. Al primo tocco su «Voce attiva» si sblocca. Sui tablet senza voci italiane c'è la voce di riserva del server.",
    to: "/impostazioni",
    cta: "Prova la voce",
  },
  {
    v: "2.4",
    data: "04/07/2026",
    titolo: "Voce naturale per gli annunci",
    testo: "Ora in cucina parla una voce di qualità professionale, non più quella metallica del telefono. L'annuncio dice il tavolo e quante portate sono arrivate; col piano Pro legge anche i nomi dei piatti e scegli fra sei voci.",
    to: "/impostazioni",
    cta: "Ascolta la voce",
  },
  {
    v: "2.2",
    data: "04/07/2026",
    titolo: "Informativa privacy da accettare una volta",
    testo: "Al primo accesso il titolare vede cosa Reprehendo può vedere e cosa non vedrà mai (i tuoi incassi non li vediamo). L'accettazione resta registrata con data, ora e nome; il documento si riscarica sempre da Impostazioni.",
    to: "/impostazioni",
    cta: "Scarica il documento",
  },
  {
    v: "2.1",
    data: "04/07/2026",
    titolo: "«Situazione adesso» in cima alla home",
    testo: "Incassato, soldi ancora da incassare sui tavoli aperti, contanti attesi in cassa e differenza dell'ultima conta. Sotto, gli avvisi: contanti non versati, pagamenti da confermare, piatti finiti, prenotazioni di oggi.",
    to: "/",
    cta: "Guarda la home",
  },
  {
    v: "2.1",
    data: "04/07/2026",
    titolo: "Chiusura serata con i controlli",
    testo: "Prima di archiviare ti dico cosa resta indietro: tavoli aperti, pagamenti da confermare, contanti non versati e conta non fatta. Puoi chiudere comunque, ma sapendo cosa chiudi.",
    to: "/",
    cta: "Prova la chiusura",
  },
  {
    v: "2.1",
    data: "04/07/2026",
    titolo: "Movimenti per il commercialista",
    testo: "Filtro per giorno e persona, totali per tipo di azione e scarico in CSV di tutta la giornata.",
    to: "/movimenti",
    cta: "Apri i movimenti",
  },
  {
    v: "2.0",
    data: "03/07/2026",
    titolo: "Scegli solo le funzioni che ti servono",
    testo: "Nel test attività dici se usi menu fisso, carta QR e cassa fiscale: quelle che non ti servono non compaiono nel menu. Si accendono quando vuoi da Funzioni attive.",
    to: "/funzioni",
    cta: "Vedi le funzioni attive",
  },
  {
    v: "2.0",
    data: "03/07/2026",
    titolo: "Carta digitale con QR da tavolo",
    testo: "I clienti leggono il menu dal telefono inquadrando il QR sul tavolo. Prezzi sempre aggiornati, nessuna ristampa.",
    to: "/menu-fisso",
    cta: "Scarica il QR",
  },
  {
    v: "2.0",
    data: "03/07/2026",
    titolo: "Menu fisso: il cameriere sceglie i piatti",
    testo: "Aggiungendo un menu fisso alla comanda si scelgono Antipasto, Primo, Secondo e Contorno: una riga sul conto, i piatti vanno in cucina.",
    to: "/menu-fisso",
    cta: "Configura il menu fisso",
  },
  {
    v: "2.0",
    data: "03/07/2026",
    titolo: "Cassa fiscale collegata",
    testo: "Scontrino preparato dall'app per Epson, RCH, Ditron, Custom e Olivetti. Prova con l'ultimo conto prima del servizio.",
    to: "/cassa-fiscale",
    cta: "Imposta la cassa",
  },
  {
    v: "1.9",
    data: "30/06/2026",
    titolo: "Prova gratuita sotto controllo",
    testo: "Allo scadere dei 7 giorni si passa al piano Gratuito senza perdere nessun dato: sala, comande e conti restano attivi.",
    to: "/abbonamento",
    cta: "Vedi i piani",
  },
  {
    v: "1.9",
    data: "30/06/2026",
    titolo: "App più comoda sul telefono",
    testo: "Barra di navigazione in basso, carrello sempre a portata nella comanda e installazione su schermata Home.",
    to: "/manuale",
    cta: "Leggi il manuale",
  },
];
